import AppErrorPage from '@/components/AppErrorPage'

export default function NotFound() {
  return (
    <AppErrorPage
      eyebrow="Not Found"
      title="That page does not exist"
      description="The URL you entered does not match a public page or an available in-app route."
      details="If you followed an old bookmark or shared link, it may have been moved or removed."
      primaryAction={{ label: 'Go to dashboard', to: '/' }}
      secondaryAction={{ label: 'Sign in', to: '/login' }}
    />
  )
}
